import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { notify } from "@/components/framework/notify";
import { t } from "@/i18n";

export const useUserProfileCompletionSetReminder = (stageId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["userProfileCompletionSetReminder", stageId],
    mutationFn: () => {
      return apiClient.post(`users/profile-completion/${stageId}/reminded`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["userProfileCompletion"]);
    },
    onError: () => {
      notify("error", t("generic.unknown_error"));
    },
  });
};

export const useUserProfileCompletionClearReminder = (stageId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["userProfileCompletionClearReminder", stageId],
    mutationFn: () => {
      return apiClient.delete(`users/profile-completion/${stageId}/reminded`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["userProfileCompletion"]);
    },
    onError: () => {
      notify("error", t("generic.unknown_error"));
    },
  });
};

export const useUserProfileCompletionSkipStage = (stageId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["skipUserProfileCompletionStage", stageId],
    mutationFn: () => {
      return apiClient.post(`users/profile-completion/${stageId}/skip`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["userProfileCompletion"]);
    },
    onError: () => {
      notify("error", t("generic.unknown_error"));
    },
  });
};

export const useUserProfileCompletionUnskipStage = (stageId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["unskipUserProfileCompletionStage", stageId],
    mutationFn: () => {
      return apiClient.delete(`users/profile-completion/${stageId}/skip`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["userProfileCompletion"]);
    },
    onError: () => {
      notify("error", t("generic.unknown_error"));
    },
  });
};
